import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import * as Icons from "../Icons/Icons";

import VerticalNavTopLevelContainer from "./VerticalNavTopLevelContainer";
import VerticalNavSubLevelContainer from "./VerticalNavSubLevelContainer";
import VerticalNavItem from "./VerticalNavItem";

import "./vertical-nav.scss";
import BaseAnchor from "../Anchor/BaseAnchor";

const getMenuItems = menu => {
  const subMenus = [];

  const menuItems = array => {
    const sectionParent = array[0];

    array.forEach(item => {
      if (item.subLinks && item.subLinks.length > 0) {
        subMenus.push({
          parentId: sectionParent.id,
          parentName: sectionParent.name,
          parentUrl: sectionParent.to,
          sectionId: item.id,
          links: item.subLinks,
        });
        menuItems(item.subLinks);
      }
    });
  };

  menuItems(menu);

  return subMenus;
};

class VerticalNav extends Component {
  renderTopLevelItems() {
    const { navigation, currentUrl, onItemClick, currentLevel, headerButton } = this.props;
    const sectionId = navigation[0].id;
    const isActiveSection = currentLevel === 0;
    return (
      <nav className="vertical-nav__root-block">
        <VerticalNavTopLevelContainer>
          {headerButton && (
            <div className="vertical-nav__back-btn-container">
              <BaseAnchor
                className="vertical-nav__back-btn"
                to={headerButton.to}
                onClick={headerButton.onClick}
                title={headerButton.text}
              >
                {headerButton.icon && headerButton.icon({ className: "vertical-nav__arrow-icon" })}
                {headerButton.text}
              </BaseAnchor>
            </div>
          )}
          {navigation.map(({ id, name, subLinks, to, icon, notifications }) => {
            const hasSubMenu = subLinks && subLinks.length > 0;
            const isActive = to === currentUrl;
            const itemProps = {
              key: id,
              id,
              isActive,
              text: name,
              hasSubMenu,
              notifications,
              to,
              onClick: () => {
                onItemClick(to, hasSubMenu, id, sectionId);
              },
            };

            if (icon) {
              itemProps.icon = icon in Icons ? Icons[icon]() : null;
            }

            return <VerticalNavItem {...itemProps} tabIndex={isActiveSection ? "0" : "-1"} />;
          })}
        </VerticalNavTopLevelContainer>
      </nav>
    );
  }

  renderSubLevelItems() {
    const {
      currentLevel,
      currentMenu,
      currentUrl,
      onItemClick,
      onBackBtnClick,
      previousMenu,
      navigation,
    } = this.props;

    const subMenus = getMenuItems(navigation);

    return (
      <Fragment>
        {subMenus.map((menu, i) => {
          const { parentId, parentName, sectionId, parentUrl, links } = menu;
          const hasFocus = sectionId === currentMenu;
          const isActiveSection = currentLevel > 0 && (hasFocus || sectionId === previousMenu);

          return (
            <VerticalNavSubLevelContainer
              id={sectionId}
              key={`${parentId}_${i}`}
              isActiveSection={isActiveSection}
              parentSectionName={parentName}
              parentUrl={parentUrl}
              onClick={() => onBackBtnClick(parentUrl, parentId, sectionId)}
            >
              {links &&
                links.map(item => {
                  const hasSubMenu = item.subLinks && item.subLinks.length > 0;
                  const isActive = item.to === currentUrl;

                  return (
                    <VerticalNavItem
                      key={item.id}
                      id={item.id}
                      text={item.name}
                      to={item.to}
                      onClick={() => {
                        onItemClick(item.to, hasSubMenu, item.id, sectionId);
                      }}
                      isActive={isActive}
                      hasSubMenu={hasSubMenu}
                      notifications={item.notifications}
                      tabIndex={hasFocus ? "0" : "-1"}
                    />
                  );
                })}
            </VerticalNavSubLevelContainer>
          );
        })}
      </Fragment>
    );
  }

  render() {
    const { currentLevel, headerButton } = this.props;
    const position = -currentLevel * 100;

    return (
      <div
        className={classnames("vertical-nav", {
          "vertical-nav--has-header-button": headerButton,
        })}
      >
        <div
          className="vertical-nav__inner"
          style={{ transform: `translate(${position}%)` }}
          role="menu"
        >
          {this.renderTopLevelItems()}
          {this.renderSubLevelItems()}
        </div>
      </div>
    );
  }
}

VerticalNav.propTypes = {
  previousMenu: PropTypes.string,
  currentUrl: PropTypes.string.isRequired,
  currentMenu: PropTypes.string.isRequired,
  currentLevel: PropTypes.number.isRequired,
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      notifications: PropTypes.number,
      subLinks: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          to: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  onItemClick: PropTypes.func.isRequired,
  onBackBtnClick: PropTypes.func.isRequired,
  headerButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    icon: PropTypes.func,
    to: PropTypes.string,
  }),
};

export default VerticalNav;
